import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from '@/patient-app-common/localization/localization';

import { getStoredLanguage, storeLanguage } from './utils';

const initialLanguage = getStoredLanguage() || 'en';

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // react already safe from xss
    },
    ns: [
      'common',
      'education',
      'home',
      'login',
      'progress',
      'settings',
      'survey',
      'todo',
      'chatbot',
    ],
    defaultNS: 'common',
    fallbackNS: 'common',
  })
  .then(() => {
    i18next.on('languageChanged', (language) => {
      storeLanguage(language);
      if (typeof document !== 'undefined') {
        document.documentElement.lang = language;
      }
    });
  });

document.documentElement.lang = i18next.language;

export default i18next;
